import { ChangeEvent, FC } from 'react';
import { PickUpConditionHooksType } from 'components/SearchConditionSettingForm/types';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { SearchCheckboxItem } from 'components/SearchCheckboxList';
import { PickUpConditionType } from 'types/pickUpConditions';
import styles from './index.module.scss';

/**
 * 検索条件設定コンポーネント こだわり条件ピックアップ の Props
 */
interface Props {
  /** こだわり条件ピックアップ関連のフックタイプ */
  pickUpCondition: PickUpConditionHooksType;
  /** 求人数を更新するための関数 */
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
}

/**
 * 検索条件設定コンポーネント こだわり条件ピックアップ
 *
 * @param {Props} props - こだわり条件ピックアップの検索条件設定に必要なプロパティ
 * @returns {JSX.Element} Reactコンポーネント
 */
export const KodawariContents: FC<Props> = ({
  pickUpCondition,
  updateJobCount,
}) => {
  const {
    pickUpConditionDisplayList,
    updateIsCheckedIsNewArrival,
    updateIsCheckedIsNearDeadline,
    updateIsCheckedHolidayAndWayOfWorkingList,
    updateIsCheckedRequirementList,
  } = pickUpCondition;
  const onChangeCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    pickUpType: PickUpConditionType
  ) => {
    switch (pickUpType) {
      case 'newArrival':
        updateIsCheckedIsNewArrival(event);
        updateJobCount({ isNewArrival: event.target.checked });
        break;
      case 'nearDeadline':
        updateIsCheckedIsNearDeadline(event);
        updateJobCount({ isNearDeadline: event.target.checked });
        break;
      case 'holidayAndWayOfWorking': {
        const checkedList = updateIsCheckedHolidayAndWayOfWorkingList(event);
        updateJobCount({ holidayAndWayOfWorking: checkedList });
        break;
      }
      case 'requirement': {
        const checkedList = updateIsCheckedRequirementList(event);
        updateJobCount({ requirements: checkedList });
        break;
      }
      default:
        break;
    }
  };

  return (
    <div className={styles.searchConditionSettingForm__kodawariContents}>
      <ul className={styles.searchCheckboxListWrapper}>
        {pickUpConditionDisplayList.map(
          ({ id, name, value, isChecked, type }) => (
            <li key={id}>
              <SearchCheckboxItem
                title={name}
                value={value}
                isChecked={isChecked}
                onChange={(event) => onChangeCheckbox(event, type)}
                size="L"
              />
            </li>
          )
        )}
      </ul>
    </div>
  );
};
